export const isFinished = (closeTime: string) => {
  if(!closeTime) return true;
  const currentDate = new Date(Date.now());
  const endDate = new Date(closeTime);
  if (!closeTime) return true;
  return endDate < currentDate;
};
